import { string, any, oneOf, object } from 'prop-types'
import { kuiperClassNames } from '../utils'
import './styles.scss'

const Bar = ({
  align,
  styles = {},
  color = 'n10',
  children,
  className,
  height = 'medium',
}) => (
  <div
    className={kuiperClassNames(
      `bar bg-color-${color}`,
      className,
      align,
      height
    )}
    style={styles}
  >
    {children}
  </div>
)

Bar.propTypes = {
  align: oneOf(['fill', 'right', 'center']),
  children: any,
  className: string,
  color: string,
  height: oneOf(['small', 'medium', 'large', 'xlarge']),
  styles: object,
}

export default Bar
